import { FC } from 'react';
import { SurveyStatisticPage } from './survey-statistic.page';
import { useSessionStorage } from '../../../../../hooks';
import { getLocalStorageDistrictId } from '../../../../_core/utils';

export const SurveyStatisticsDistrictLevelPage: FC = () => {
	const [sessionStorageDistrictId] = useSessionStorage('districtId');

	const districtId = sessionStorageDistrictId ?? getLocalStorageDistrictId();
	return <SurveyStatisticPage isAdminRoute={false} currentDistrictId={districtId} />;
};
